import React, { useState, useEffect } from 'react'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import ReportNavbar from './ReportNavbar'
import { MDBDataTable } from 'mdbreact'
import { ReportMemberListApi, ReportVaccantList } from '../../ApiFile'
import { Col, Row } from 'react-bootstrap'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import MobileNavbarAdmin from '../pages/MobileNavbarAdmin'

const VacantRoomBed = () => {
  const [members, setMembers] = useState([])

  useEffect(() => {
    fetch(ReportVaccantList)
      .then((response) => response.json())
      .then((data) => setMembers(data))
      .catch((error) => console.error('Error fetching member list:', error))
  }, [])

  const rows = members.map((member, index) => ({
    serial: index + 1,
    block_id: member.block_id,
    room_id: member.room_id,
    bed_id: member.bed_id,
  }))

  const data = {
    columns: [
      {
        label: 'Serial No',
        field: 'serial',
        sort: 'asc',
      },
      {
        label: 'Block No',
        field: 'block_id',
        sort: 'asc',
      },
      {
        label: 'Room No',
        field: 'room_id',
        sort: 'asc',
      },
      {
        label: 'Bed No',
        field: 'bed_id',
        sort: 'asc',
      },
    ],
    rows: rows,
  }

  const handleExcelData = () => {
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })

    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'Vacant_RoomBed_Data.xlsx'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    toast.success('Excel Sheet Downloaded !!!', {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  }

  const handlePdfData = () => {
    const doc = new jsPDF()
    const columns = data.columns.map((col) => col.label)
    const rowsData = rows.map((row) => [
      row.serial,
      row.block_id,
      row.room_id,
      row.bed_id,
    ])

    const title = 'Vacant Room-Bed Data'

    const pageWidth = doc.internal.pageSize.getWidth()
    const textWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor
    const x = (pageWidth - textWidth) / 2
    doc.text(title, x, 10)

    doc.autoTable({
      head: [columns],
      body: rowsData,
      startY: 20,
    })

    const blob = doc.output('blob')
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'Vacant_RoomBed_Data.pdf'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    toast.success('PDF Downloaded !!!', {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  }

  return (
    <>
      <div
        className="roomchange-container"
        style={{ display: 'flex', minHeight: '100vh' }}
      >
        {/* Sidebar on the left for desktop */}
        <div
          className="d-none d-md-block sidebar-container"
          style={{ width: '270px', flexShrink: 0 }}
        >
          <Sidebar />
        </div>

        {/* Main content on the right */}
        <div
          className="main-content flex-grow-1"
          style={{ flex: 1, backgroundColor: '#f8f9fa' }}
        >
          <NavLogo />

          <div className="d-block d-md-none">
            <MobileNavbarAdmin />
          </div>
          <ReportNavbar />

          <div
            className="border w-100 h-100 py-3"
            style={{ backgroundColor: '#f5f5f5ff' }}
          >
            <Row className="m-0 p-0 px-3">
              <Col
                className="rounded text-center py-2"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  // backgroundColor: 'white',
                  border: '0px',
                  alignItems: 'center',
                  alignContent: 'center',
                  color: 'maroon',
                }}
              >
                <h5
                  className="room-change-title text-start"
                  style={{ color: '#0783d6' }}
                >
                  Vacant Room-Bed List
                </h5>
                <div>
                  <Button
                    className="mx-1 p-0"
                    style={{
                      border: '1px solid',
                      backgroundColor: '#3b9cfd',
                      color: 'white',
                    }}
                    onClick={() => handleExcelData()}
                  >
                    Excel
                  </Button>
                  <Button
                    className="mx-1 p-0"
                    style={{
                      border: '1px solid',
                      backgroundColor: '#136fcb',
                      color: 'white',
                    }}
                    onClick={() => handlePdfData()}
                  >
                    Pdf
                  </Button>
                </div>
              </Col>
            </Row>

            <Row
              className="m-0 p-0 px-md-3 py-1 pb-5  w-100 mb-5"
              style={{ display: 'flex' }}
            >
              <Col
                className="m-0 p-0 px-3 py-3 rounded shadow"
                style={{ background: 'white', overflowX: 'auto' }}
              >
                <MDBDataTable
                  striped
                  bordered
                  className="custom-datatable"
                  small
                  data={data}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

export default VacantRoomBed
